import React from "react";
import AttchedFiles from "../Attachments/AttchedFiles";
import AudioResponse from "../Attachments/AudioResponse";
import LinkAnalysis from "../Attachments/LinkAnalysis";
import TextResponse from "../Attachments/TextResponse";
import VideoResponse from "../Attachments/VideoResponse";

export const RenderAttachmentContent = ({
  attachment,
  isAnnotationMode,
  gradingResult,
}) => {
  console.log("gradingResult.annotations", gradingResult.annotations)
  console.log("attachment", attachment)
  
  const attachmentAnnotations =
    gradingResult.annotations.find(
      (annotation) => annotation.id === attachment.id
    ) || {};

  switch (attachment.type) {
    case "text":
      return (
        <TextResponse
          text={attachment}
          existingAnnotations={attachmentAnnotations}
          isAnnotationMode={isAnnotationMode}
        />
      );
    case "voice":
      return (
        <AudioResponse
          audio={attachment}
          isAnnotationMode={isAnnotationMode}
          existingAnnotations={attachmentAnnotations}
        />
      );
    case "video":
      return (
        <VideoResponse
          video={attachment}
          isAnnotationMode={isAnnotationMode}
          existingAnnotations={attachmentAnnotations}
        />
      );
    case "link":
      return (
        <LinkAnalysis
          link={attachment}
          isAnnotationMode={isAnnotationMode}
          existingAnnotations={attachmentAnnotations}
        />
      );
    case "file":
      return (
        <AttchedFiles
          files={attachment}
          isAnnotationMode={isAnnotationMode}
          existingAnnotations={attachmentAnnotations}
        />
      );
    default:
      return null;
  }
};
